import { environment } from 'environments/environment';
import { getFiBankStore } from 'stores/FiBankStore';
import { Attachments } from 'ui/molecules';

export const PreviewCustomFormAttachments: React.FC<{
  attachmentsPadding?: string;
  attachments?: { file_name: string; id: string }[];
  noLabel?: boolean;
  label?: string;
  labelColor?: 'gray' | 'black';
  orgId?: string;
}> = (props) => {
  const { attachments, orgId } = props;

  const fiBankStore = getFiBankStore();

  if (!attachments?.length) {
    return null;
  }

  const verboseAttachments = attachments.map((attachment) => {
    return {
      ...attachment,
      orgId: orgId ?? fiBankStore.bank.id,
      bucket: environment.storageConfig.sharedDocument
    };
  });

  return <Attachments {...props} attachments={verboseAttachments} />;
};
